module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS9.9098f755.jpg";